import { jsxs as j, jsx as a } from "react/jsx-runtime";
import E, { memo as F, useCallback as u } from "react";
import { Row as N, Col as y } from "antd";
import { u as L } from "../../styled-components.browser.esm-BFmoFexH.js";
import { _ as O } from "../../lodash-DeBCDn4U.js";
import W from "./box/Box.js";
import { useEventResolver as C, useLanguageResolver as I } from "@biron-data/react-contexts";
import { NUMBER_OF_FILTER_PER_LINE as P } from "./BoxWrapper.constants.js";
import k from "./boxWithDescription/BoxWithDescription.js";
const K = F(function({
  filters: o = [],
  label: m,
  layout: l,
  seeDescription: s,
  className: d,
  onFiltersChange: c,
  numberOfFilterPerLine: x = P,
  bordered: f,
  getPopupContainer: _,
  GACategory: p,
  isResumable: $,
  isEditable: v = !0,
  loadDictionaryEntries: b
}) {
  const i = C(), h = I(), w = u((t, e) => {
    const n = Object.assign([], o);
    n[e] = t, c([...n]), i.capture({
      category: p,
      action: `add_${t.type}_filter_values`
    });
  }, [p, i, o, c]), R = u((t) => {
    var n;
    const e = Object.assign([], o);
    e.splice(t, 1), c([...e]), i.capture({
      category: p,
      action: `remove_${(n = e[t]) == null ? void 0 : n.type}_filter`
    });
  }, [p, i, o, c]);
  return /* @__PURE__ */ j("div", { className: `boxes-wrapper boxes-wrapper-layout-${l} ${d}`, children: [
    m && /* @__PURE__ */ a("div", { className: "boxes-wrapper-label", children: h.get(m) }),
    /* @__PURE__ */ a(N, { gutter: [10, 10], children: o.map((t, e) => {
      const B = /* @__PURE__ */ a(
        s ? k : W,
        {
          filter: t,
          close: () => R(e),
          handleFilterChange: (g) => w(g, e),
          bordered: f,
          getPopupContainer: _,
          isResumable: $,
          isEditable: v,
          loadDictionaryEntries: b
        },
        e
      );
      return /* @__PURE__ */ a(D, { $nb: x, children: /* @__PURE__ */ a(E.Fragment, { children: B }, e) }, e);
    }) })
  ] });
}), D = L(y)`
    flex: 0 0 ${({ $nb: r }) => 100 / r}%;
    max-width: ${({ $nb: r }) => 100 / r}%;
  
  ${(r) => {
  const o = [1550, 1250, 950, 750];
  return O.compact(o.map((m, l) => {
    const s = r.$nb - (l + 1);
    if (s > 0)
      return `@media (max-width: ${m}px) {
              flex: 0 0 ${100 / s}%;
              max-width: ${100 / s}%;
          }`;
  })).join("");
}}
`;
export {
  K as default
};
//# sourceMappingURL=BoxesWrapper.js.map
